
<div :class="classes(n())">
  <HalfScreenDialog
    v-model:visible="currentVisible"
    :visible.sync="currentVisible"
    :class="n('dialog')"
    :title="title"
    :show-close="showClose"
    :scrollable="false"
    :close-on-click-overlay="closeOnClickOverlay"
    :lock-scroll="lockScroll"
    :destroy-on-close="destroyOnClose"
    :teleport="teleport"
    :actions="confirmActions"
    @close="handleCancel"
    @action-click="handleConfirm"
    @click-overlay="handleOverlayClick"
  >
    <!-- 自定义整个 toolbar -->
    <template
      v-if="$slots.toolbar"
      #header
    >
      <slot name="toolbar" />
    </template>

    <!-- 自定义标题 -->
    <template
      v-if="$slots.title"
      #header-center
    >
      <slot name="title" />
    </template>

    <!-- 列上方自定义内容 -->
    <slot name="columns-top" />

    <!-- 选择器列区域 -->
    <div
      :class="classes(
        n('content'),
        { [n('content--disabled')]: disabled }
      )"
    >
      <div
        :class="n('columns')"
        :style="columnsStyle"
      >
        <div :class="n('columns__bar')" />
        <div :class="classes(n('columns__mask'), n('columns__mask--top'))" />
        <div :class="classes(n('columns__mask'), n('columns__mask--bottom'))" />
        <div :class="n('columns__inner')">
          <PickerColumn
            v-for="(columnOptions, colIdx) in normalizedColumns"
            :key="`col-${colIdx}-${columnOptions.length}`"
            ref="columnRefs"
            :options="columnOptions"
            :value="internalValues[colIdx]"
            :column-index="colIdx"
            :visible-option-num="visibleOptionNum"
            :option-height="optionHeight"
            :swipe-duration="swipeDuration"
            :disabled="disabled"
            :columns-field-names="columnsFieldNames"
            @change="handleColumnChange"
          >
            <template
              v-if="$slots.option"
              #option="slotProps"
            >
              <slot
                name="option"
                v-bind="slotProps"
              />
            </template>
          </PickerColumn>
        </div>
      </div>
    </div>

    <!-- 列下方自定义内容 -->
    <slot name="columns-bottom" />

    <!-- 自定义确认按钮 -->
    <template
      v-if="$slots.confirm"
      #footer
    >
      <slot name="confirm" />
    </template>
  </HalfScreenDialog>
</div>
